import springApi, { getDomain } from '../../services/springApi'

export const getSstPosts = params => (
	new Promise((resolve, reject) => {
		springApi()
			.get('/sst_posts', { params })
				.then(res => resolve(res))
				.catch(error => reject(error))
	})
)

export const getSstPost = (id, params) => (
	new Promise((resolve, reject) => {
		springApi()
			.get(`/sst_posts/${id}`, { params })
				.then(res => resolve(res))
				.catch(error => reject(error))
	})
)

export const storeSstPost = data => (
	new Promise((resolve, reject) => {
		springApi()
			.post('/sst_posts', data)
				.then(res => resolve(res))
				.catch(error => reject(error))
	})
)

export const updateSstPost = (id, data) => (
	new Promise((resolve, reject) => {
		springApi()
			.put(`/sst_posts/${id}`, data)
				.then(res => resolve(res))
				.catch(error => reject(error))
	})
)

export const deleteSstPost = id => (
	new Promise((resolve, reject) => {
		springApi()
			.delete(`/sst_posts/${id}`)
				.then(res => resolve(res))
				.catch(error => reject(error))
	})
)

export const searchSstPosts = async (name, token) => (
	fetch( getDomain()+`/sst_posts?filter[name]=${name}`, {
		headers: {'Authorization': `Bearer ${token}`}
	})
		.then((response) => response.json())
		.then((res) =>
			res.data.map(sst_post => ({
				label: sst_post.name,
				value: sst_post.id,
			})),
		)
)

export const toggleDepartment = data => (
	new Promise((resolve, reject) => {
		springApi()
			.post('/department_sst_post', data)
				.then(res => resolve(res))
				.catch(error => reject(error))
	})
)

export const toggleOnAllDepartments = data => (
	new Promise((resolve, reject) => {
		springApi()
			.post('/department_sst_post/all_on', data)
				.then(res => resolve(res))
				.catch(error => reject(error))
	})
)